import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class BetSummaryService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getSummaryBetMonthly(params: {
    startDate: string;
    endDate: string;
    accountId?: string;
    document?: string;
  }): Observable<any> {
    let queryParams = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate);

    if (params.accountId) queryParams = queryParams.set('accountId', params.accountId);
    if (params.document) queryParams = queryParams.set('document', params.document);

    return this.http.get<any>(this.url('/summaryBetMontly'), {
      params: queryParams,
    });
  }

  getSummaryBet(params: {
    startDate: string;
    endDate: string;
    page: number;
    pageSize: number;
    accountId?: string;
    document?: string;
  }): Observable<any> {
    let queryParams = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate)
      .set('pageSize', params.pageSize)
      .set('page', params.page);

    if (params.accountId) queryParams = queryParams.set('accountId', params.accountId);
    if (params.document) queryParams = queryParams.set('document', params.document);

    return this.http.get<any>(this.url('/summaryBet'), {
      params: queryParams,
    });
  }

  exportSummaryBetPdf(params: {
    startDate: string;
    endDate: string;
    accountId?: string;
    document?: string;
  }): Observable<any> {
    const payload: any = {
      startDate: params.startDate,
      endDate: params.endDate,
    };

    if (params.accountId) payload.accountId = params.accountId;
    if (params.document) payload.document = params.document;

    return this.http.post<any>(this.url('/reports/summary-bet'), payload);
  }
}